import React from 'react';
import GlobalStyles, { StyledToastContainer } from './styles/GlobalStyles.styles';
import Router from './Router';
import { BrowserRouter } from 'react-router-dom';
import { AuthContextProvider } from './Context/authContext';
import 'react-toastify/dist/ReactToastify.min.css';
import '@szhsin/react-menu/dist/index.css';
import '@szhsin/react-menu/dist/transitions/zoom.css';
import { MQTTContextProvider } from './Context/MqttContext';
const App = () => {
  // useEffect(() => {
  //     const requestFullscreen = () => {
  //         const element = document.documentElement;
  //         if (element.requestFullscreen) {
  //             element.requestFullscreen();
  //         } else if (element.mozRequestFullScreen) {
  //             element.mozRequestFullScreen();
  //         } else if (element.webkitRequestFullscreen) {
  //             element.webkitRequestFullscreen();
  //         } else if (element.msRequestFullscreen) {
  //             element.msRequestFullscreen();
  //         }
  //     };

  //     // This will attempt fullscreen when the component mounts
  //     // Ideally, tie this to a button or user interaction
  //     const handleKeyPress = event => {
  //         if (event.key === "Enter") {
  //             // Or any other key you choose
  //             requestFullscreen();
  //         }
  //     };

  //     document.addEventListener("keypress", handleKeyPress);

  //     return () => {
  //         document.removeEventListener("keypress", handleKeyPress);
  //     };
  // }, []);

  return (
    <>
      <AuthContextProvider>
        <MQTTContextProvider>
          <BrowserRouter>
            <GlobalStyles />
            <Router />
          </BrowserRouter>
          <StyledToastContainer />
        </MQTTContextProvider>
      </AuthContextProvider>
    </>
  );
};

export default App;
